import type { ProductCategoryOverlayConfig } from "./ProductCategoryOverlay";

export const productCategoryOverlays = [
  {
    categoryKey: "beer",
    label: "Beer",
    groups: [
      {
        id: "containers",
        options: [
          {
            id: "keg",
            label: "Beer in keg",
            preset: { containerTypes: ["keg"] },
          },
          {
            id: "cask",
            label: "Beer in cask",
            preset: { containerTypes: ["cask"] },
          },
          {
            id: "can",
            label: "Beer in cans",
            preset: { containerTypes: ["can"] },
          },
          {
            id: "bottle",
            label: "Beer in bottles",
            preset: { containerTypes: ["bottle"] },
          },
        ],
      },
      {
        id: "browse",
        options: [
          {
            id: "low-no",
            label: "Low & no beer",
            preset: { abvRange: { type: "between", low: 0, high: 2 } },
          },
          {
            id: "latest",
            label: "Latest in beer",
            preset: { orderBy: "updatedAt" },
          },
          { id: "all", label: "All beer", preset: {} },
        ],
      },
    ],
  },
  {
    categoryKey: "cider",
    label: "Cider",
    groups: [
      {
        id: "containers",
        options: [
          {
            id: "keg",
            label: "Cider in keg",
            preset: { containerTypes: ["keg"] },
          },
          {
            id: "bag-in-box",
            label: "Cider in bag-in-box",
            preset: { containerTypes: ["bagInBox"] },
          },
          {
            id: "can",
            label: "Cider in cans",
            preset: { containerTypes: ["can"] },
          },
          {
            id: "bottle",
            label: "Cider in bottles",
            preset: { containerTypes: ["bottle"] },
          },
        ],
      },
      {
        id: "browse",
        options: [
          {
            id: "low-no",
            label: "Low & no cider",
            preset: { abvRange: { type: "between", low: 0, high: 2 } },
          },
          {
            id: "latest",
            label: "Latest in cider",
            preset: { orderBy: "updatedAt" },
          },
          { id: "all", label: "All cider", preset: {} },
        ],
      },
    ],
  },
  {
    categoryKey: "wine",
    label: "Wine",
    groups: [
      {
        id: "styles",
        options: [
          {
            id: "red",
            label: "Red",
            preset: { styleSearchValues: ["red & wine"] },
          },
          {
            id: "white",
            label: "White",
            preset: { styleSearchValues: ["white & wine"] },
          },
          {
            id: "rose",
            label: "Rosé",
            preset: { styleSearchValues: ["rosé & wine"] },
          },
          {
            id: "orange",
            label: "Orange",
            preset: { styleSearchValues: ["orange & wine"] },
          },
          {
            id: "sparkling",
            label: "Sparkling",
            preset: { styleSearchValues: ["sparkling & wine"] },
          },
        ],
      },
      {
        id: "browse",
        options: [
          {
            id: "low-no",
            label: "Low & no wine",
            preset: { abvRange: { type: "between", low: 0, high: 10 } },
          },
          {
            id: "latest",
            label: "Latest wine",
            preset: { orderBy: "updatedAt" },
          },
          { id: "all", label: "All wine", preset: {} },
        ],
      },
    ],
  },
  {
    categoryKey: "spirits",
    label: "Spirits",
    groups: [
      {
        id: "styles",
        options: [
          {
            id: "whisky",
            label: "Whisky",
            preset: { styleSearchValues: ["whisky|whiskey"] },
          },
          {
            id: "vodka",
            label: "Vodka",
            preset: { styleSearchValues: ["vodka"] },
          },
          { id: "rum", label: "Rum", preset: { styleSearchValues: ["rum"] } },
          { id: "gin", label: "Gin", preset: { styleSearchValues: ["gin"] } },
          {
            id: "rtd",
            label: "Ready to drink",
            preset: { styleSearchValues: ["rtd"] },
          },
        ],
      },
      {
        id: "browse",
        options: [
          {
            id: "low-no",
            label: "Low & no spirits",
            preset: { abvRange: { type: "between", low: 0, high: 2 } },
          },
          {
            id: "latest",
            label: "Latest in spirits",
            preset: { orderBy: "updatedAt" },
          },
          { id: "all", label: "All spirits", preset: {} },
        ],
      },
    ],
  },
  {
    categoryKey: "softDrinks",
    label: "Softs",
    groups: [
      {
        id: "styles",
        options: [
          {
            id: "kombucha",
            label: "Kombucha",
            preset: { styleSearchValues: ["kombucha"] },
          },
          {
            id: "soda",
            label: "Soda",
            preset: { styleSearchValues: ["soda"] },
          },
          {
            id: "juice",
            label: "Juices",
            preset: { styleSearchValues: ["juice"] },
          },
        ],
      },
      {
        id: "browse",
        options: [
          {
            id: "latest",
            label: "Latest softs",
            preset: { orderBy: "updatedAt" },
          },
          { id: "all", label: "All softs", preset: {} },
        ],
      },
    ],
  },
] as const satisfies readonly ProductCategoryOverlayConfig[];
